<template>
    <div class="personnelAdd">
        <Head-view :showStyle="1"></Head-view>
        <div class="main">
            <div class="breadcrumb" @click="backClose()">
                人员管理 &nbsp;/&nbsp;
                <span style="color: rgba(132, 133, 135, 1)">{{
                    editTitle
                }}</span>
            </div>
            <div class="breadcrumbChilder">{{ editTitle }}</div>
            <div class="showTba">
                <div class="addBox">
                    <div class="instMsg">人员信息</div>
                    <div class="commRowstyle logo">
                        <div class="inpTitle logoSplick">头像</div>
                        <div class="addHeadImg">
                            <input
                                type="file"
                                name="file"
                                ref="headImgRef"
                                accept="image/*,.jpg,.png,.git,.webp,.svg,"
                                @change="uploadHeadImg()"
                                v-if="!imgHead"
                            />
                            <img :src="imgHead" v-if="imgHead" alt="" />
                            <div
                                class="delHeadImg"
                                v-if="imgHead"
                                @click="delHeadImg()"
                            >
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle"><span>*</span>姓名</div>
                        <div class="inpFrom">
                            <el-input
                                v-model="instMsg.name"
                                placeholder="请输入"
                                @blur="trimBoth('name', instMsg.name)"
                            ></el-input>
                        </div>
                        <div class="inpTitle marginLeft_40">
                            <span>*</span>联系电话
                        </div>
                        <div class="inpFrom">
                            <el-input
                                v-model="instMsg.phone"
                                placeholder="请选择"
                                maxlength="11"
                                @blur="trimBoth('phone', instMsg.phone)"
                            ></el-input>
                        </div>
                        <div class="inpTitle marginLeft_40">联系地址</div>
                        <div class="inpFrom">
                            <el-input
                                @blur="trimBoth('address', instMsg.address)"
                                v-model="instMsg.address"
                                placeholder="请输入"
                            ></el-input>
                        </div>
                    </div>
                    <div class="commRowstyle marginTop_30 instMsg">
                        <div class="inpTitle">部门</div>
                        <div class="inpFrom">
                            <el-select
                                v-model="depVal"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in depArr"
                                    :key="item.deptId"
                                    :label="item.name"
                                    :value="item.deptId"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="inpTitle marginLeft_40">
                            <span>*</span>角色
                        </div>
                        <div class="inpFrom">
                            <el-select
                                v-model="roleVal"
                                placeholder="请选择"
                                v-if="userRoleFlag"
                            >
                                <el-option
                                    v-for="item in rolePersonnelArr"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.label"
                                    :disabled="item.disabled"
                                >
                                </el-option>
                            </el-select>
                            <el-select
                                v-model="roleVal"
                                placeholder="请选择"
                                v-if="!userRoleFlag"
                                disabled
                            >
                                <el-option
                                    v-for="item in rolePersonnelArr"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.label"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="inpTitle marginLeft_40" v-if="!editFlag">
                            <span>*</span>初始密码
                        </div>
                        <div class="inpTitle marginLeft_40" v-if="editFlag">
                            账号
                        </div>
                        <div class="inpFrom" v-if="!editFlag">
                            <el-input
                                text="number"
                                @blur="trimBoth('password', instMsg.password)"
                                v-model="instMsg.password"
                                placeholder="888888"
                            ></el-input>
                        </div>
                        <div class="inpFrom userNum" v-if="editFlag">
                            {{ userNumber }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot">
            <div class="btn">
                <div class="commBtn closeBtn" @click="backClose()">取消</div>
                <div class="commBtn successBtn" @click="preservationData()">
                    保存
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
import { getCookie } from "../../../untils/tools";
export default {
    name: "personnelAdd",
    data() {
        return {
            imgHead: "",
            fileImg: "",
            insId: "",
            instMsg: {
                name: "",
                password: "",
                phone: "",
                address: "",
            },
            roleVal: "",
            rolePersonnelArr: [
                {
                    label: 1,
                    value: "超级管理员",
                    disabled: true
                },
                {
                    label: 2,
                    value: "管理员",
                },
                {
                    label: 3,
                    value: "巡检员",
                },
            ],

            depVal: "",
            depArr: [],

            expireDate: "",

            editTitle: "新建人员",
            editFlag: false, //是否为编辑
            userNumber: "",
            userRoleFlag: true,
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));
        let userRole = localStorage.getItem("userRole");   //当前登录账号的权限

        this.getdepInfo();
        if (this.$route.query.id) {
            this.editTitle = "编辑人员";
            this.editFlag = true;
            this.userNumber = this.$route.query.userNum;
            let userNumber = this.userNumber.substring(this.userNumber.length - 2)
            if (userNumber == '01' && this.userNumber.length <= 7) {
                this.userRoleFlag = false;
            }
        }
    },

    methods: {
        getdepInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getDeptList", data)
                .then((depRes) => {
                    if (depRes.code == 0) {
                        this.depArr = depRes.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: depRes.msg,
                        });
                    }

                    if (this.$route.query.id) {
                        this.personnelEditInfo(this.$route.query.id);
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取部门失败",
                    });
                });
        },

        personnelEditInfo(staffId) {
            let data = {
                token: this.getCookie(),
                staffId: staffId,
            };
            this.request
                .post(this.baseUrl + "institution/getStaffDetail", data)
                .then((res) => {
                    if (res.code == 0 && res.data.name) {
                        this.instMsg = res.data;
                        this.roleVal = res.data.role;
                        this.imgHead = res.data.portrait;
                        let flag = false
                        this.depArr.forEach(item => {
                            if (item.deptId == res.data.deptId) {
                                flag = true
                            }
                        })
                        this.depVal = flag ? res.data.deptId : '';

                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取详情失败",
                    });
                });
        },

        handleChange() {},

        trimBoth(type, val) {
            let trimVal = val.trim();

            switch (type) {
                case "name":
                    this.instMsg.name = trimVal;
                    break;
                case "address":
                    this.instMsg.address = trimVal;
                    break;
                case "password":
                    this.instMsg.password = trimVal;
                    break;
                case "phone":
                    var regexp = /[^\d，,]]*/g;
                    this.instMsg.phone = val.replace(regexp, "");
                    break;
                default:
                    break;
            }
        },

        uploadHeadImg() {
            //头像
            let _this = this;
            let file = this.$refs.headImgRef.files[0];
            this.fileImg = this.$refs.headImgRef.files[0];
            let imgData = new FileReader();
            imgData.readAsDataURL(file);
            imgData.onload = function (ev) {
                _this.imgHead = this.result;
            };

            // let formData = new FormData()
            // formData.append('file', file)
            // formData.append('token', this.getCookie())
            // this.request.post(this.commUrl + 'uploadFile', formData)
            //     .then(res => {
            //         console.log(res)
            //     })

        },

        delHeadImg() {
            //清空头像
            this.imgHead = "";
            this.fileImg = "";
        },

        preservationData() {
            //保存信息
            if (
                !this.instMsg.name ||
                !this.instMsg.phone ||
                !this.roleVal
            ) {
                return this.$message({
                    type: "warning",
                    message: "关键信息均不能为空",
                });
            }
            const loading = this.$loading({
                lock: true,
                text: "保存信息中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            

            if (this.imgHead && this.imgHead.indexOf("http") < 0) {
                let formData = new FormData()
                formData.append('file', this.fileImg)
                formData.append('token', this.getCookie())
                this.request
                    .post(this.commUrl + "uploadFile", formData)
                    .then((resUrl) => {
                        if (resUrl.code == 0) {
                            if (this.editFlag) {
                                this.upEditInfo(resUrl.data.url, loading);
                                return;
                            }
                            this.saveInformation(resUrl.data.url, loading);
                        } else {
                            loading.close();
                            this.$message({
                                type: "error",
                                message: resUrl.msg,
                            });
                        }
                    })
                    .catch((err) => {
                        this.$message({
                            type: "error",
                            message: err,
                        });
                    });
            } else {
                if (this.editFlag) {
                    this.upEditInfo("", loading);
                    return;
                }
                this.saveInformation("", loading);
            }
        },

        saveInformation(url = "", loading) {
            let data = {
                token: getCookie(),
                insId: this.insId,
                name: this.instMsg.name,
                portrait: url,
                phone: this.instMsg.phone,
                address: this.instMsg.address,
                password: this.instMsg.password ? this.instMsg.password : '888888',
                role: this.roleVal,
                deptId: this.depVal,
            };
            this.request
                .post(this.baseUrl + "institution/addInsStaff", data)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.result) {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "保存成功",
                            });
                            setTimeout(() => {
                                this.$message.closeAll();
                                this.$router.push("/personnel");
                            }, 1000);
                        } else {
                            loading.close();
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        upEditInfo(url = "", loading) {
            let data = {
                token: getCookie(),
                staffId: Number(this.$route.query.id),
                name: this.instMsg.name,
                portrait: url == '' ? this.imgHead : url,
                phone: this.instMsg.phone,
                address: this.instMsg.address,
                role: this.roleVal,
                deptId: this.depVal,
            };
            this.request
                .post(this.baseUrl + "institution/updateInsStaff", data)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.result) {
                            loading.close();
                            this.$message({
                                type: "success",
                                message: "修改成功",
                            });
                            setTimeout(() => {
                                this.$message.closeAll();
                                this.$router.push("/personnel");
                            }, 1000);
                        } else {
                            loading.close();
                            this.$message({
                                type: "warning",
                                message: res.msg,
                            });
                        }
                    } else {
                        loading.close();
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        upDataInst(data, timeEnd, loading) {
            //更新信息
            let upData = {
                token: getCookie(),
                name: this.instMsg.name,
                logo: data == "" ? this.imgHead : data,
                insId: this.$route.query.id,
                director: this.instMsg.director,
                phone: this.instMsg.phone,
                address: this.instMsg.address,
                expireDate: timeEnd,
            };
            this.request
                .post(this.baseUrl + "/Institution/updateIns", upData)
                .then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            type: "success",
                            message: "修改成功",
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                    loading.close();
                    setTimeout(() => {
                        this.$message.closeAll();
                        this.$router.push("/institutionList");
                    }, 1000);
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: err,
                    });
                });
        },

        isExpireDate() {
            let val = new Date(this.expireDate).getTime();
            if (val < new Date().getTime()) {
                this.expireDate = "";
                return this.$message({
                    type: "warning",
                    message: "请选择大于当前时间的日期",
                });
            }
        },

        backClose() {
            this.$router.replace("/personnel");
        },
    },
};
</script>

<style lang="less" scoped>
.personnelAdd {
    position: relative;
    height: 100vh;
    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
            cursor: pointer;
        }
        .breadcrumbChilder {
            margin-top: 24px;
            height: 20px;
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }

        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            height: 692px;
            background: #fff;
        }
    }

    .addBox {
        padding: 24px 0 0 24px;
        .instMsg {
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            font-weight: 500;
        }

        .userNum {
            line-height: 40px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
        }

        .commRowstyle {
            display: flex;
            flex-direction: row;
            .inpTitle {
                width: 107px;
                color: rgba(84, 85, 86, 1);
                font-size: 14px;
                line-height: 40px;
                font-weight: 500;
                span {
                    color: red;
                }
            }
            .inpFrom {
                width: 265px;

                input {
                    width: 100%;
                }
            }

            .codeFont {
                line-height: 40px;
                font-size: 14px;
            }
        }

        .marginTop_30 {
            margin-top: 30px;
        }

        .marginLeft_40 {
            margin-left: 40px;
            text-align: left;
        }

        .tip {
            padding-top: 21px;
            padding-left: 15px;
            color: rgba(144, 147, 153, 1);
            font-size: 13px;
            height: 19px;
            font-weight: 400;
            text-align: left;
        }

        .userNumber {
            padding-bottom: 10px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
            font-weight: 500;
        }

        .logo {
            margin-top: 12px;
            .logoSplick {
                height: 60px;
                line-height: 60px;
            }
            .addHeadImg {
                position: relative;
                width: 60px;
                height: 60px;
                border-radius: 45px;
                background: url("../../../assets/personnelAddImgHead.png")
                    no-repeat center center;
                overflow: hidden;
                input {
                    opacity: 0;
                    width: 100%;
                    height: 100%;
                }
                img {
                    width: 100%;
                }
                .delHeadImg {
                    display: none;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    color: #fff;
                    text-align: center;
                    line-height: 60px;
                }
            }
            .addHeadImg:hover .delHeadImg {
                display: block;
            }

            .tipSize {
                padding-left: 15px;
                line-height: 60px;
                color: rgba(144, 147, 153, 1);
                font-size: 13px;
                font-weight: 400;
            }
        }

        .tipBox {
            padding-left: 15px;

            > .tip {
                padding: 0;
                padding-top: 1px;
            }
        }
    }

    .foot {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 71px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;

        .btn {
            float: right;
            display: flex;
            flex-direction: row;
            padding-top: 15.5px;
            padding-right: 56px;
            .commBtn {
                width: 95px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .successBtn {
                color: rgba(255, 255, 255, 1);
                background: rgba(103, 194, 58, 1);
            }

            .closeBtn {
                margin-right: 24px;
                color: rgba(96, 98, 102, 1);
                font-size: 14px;
                font-weight: 500;
                border: 1px solid rgba(220, 223, 230, 1);
            }
        }
    }
}

/deep/ .el-input__inner {
    width: 256px;
}

.inpColorRed {
    /deep/ .el-input__inner {
        border: 1px solid red;
    }
}
</style>